import { render, staticRenderFns } from "./monitoringSystem.vue?vue&type=template&id=0a376a88&scoped=true"
import script from "./monitoringSystem.vue?vue&type=script&lang=js"
export * from "./monitoringSystem.vue?vue&type=script&lang=js"
import style0 from "./monitoringSystem.vue?vue&type=style&index=0&id=0a376a88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a376a88",
  null
  
)

export default component.exports